import React from 'react';

/**
 * Componente para renderizar uma opção dentro de um Select
 * @param {Object} props - Propriedades do componente
 * @param {string} props.value - Valor da opção
 * @param {React.ReactNode} props.children - Texto da opção
 * @returns {JSX.Element} Componente React
 */
const MenuItem = ({ value, children, ...props }) => {
  return (
    <option value={value} {...props}>
      {children}
    </option>
  );
};

export default MenuItem; 